const { isEmpty } = require('@/utils/is');

module.exports = (s) => {
  return [
    {
      name: '渠道号',
      value: 'alias',
      width: 80,
    },
    {
      name: '转化名称',
      format: (row) => {
        return row.conversion ? JSON.parse(row.conversion).name : '';
      },
    },
    {
      name: '操作',
      width: 60,
      align: 'center',
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button',
          {
            props: {
              type: 'text',
              disabled: isEmpty(row.conversion),
            },
            on: {
              click: (event) => {
                event.stopPropagation();
                s.onRemove(row);
              },
            },
          },
          '移除',
        );
        return ele;
      },
    },
  ];
};
